import React, { useEffect } from "react";
import CardInput from "../../components/CardInput";
import { callAPI } from "../../utils";

export default function PayMaya(props) {
  const headerAuth = props.authToken;
  const gwOrderId = props.tranId;
  const authenUrl = props.callBackUrl;
  const actionPage = props.action;
  const alert = props.alert;
  const setIsLoading = props.setIsLoading;
  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      const { cardNumber, cardExpiryDate, cardCVC } = data;
      const [cardExpiryMonth, cardExpiryYear] = cardExpiryDate.split(" / ");
      const tokenResponse = await callAPI(
        actionPage,
        "POST",
        {
          card: {
            number: cardNumber,
            cvc: cardCVC,
            expMonth: cardExpiryMonth,
            expYear: `20${cardExpiryYear}`,
          },
        },
        null,
        {
          "Content-Type": "application/json",
          Authorization: headerAuth,
        }
      );
      if (!tokenResponse?.paymentTokenId) {
        throw new Error("PayMaya did not return a payment token.");
      }
      const authResponse = await callAPI(authenUrl, "GET", null, {
        token: tokenResponse.paymentTokenId,
        gwOrderId,
      });
      const verificationUrl = authResponse?.response?.verificationUrl;
      if (!verificationUrl) {
        throw new Error("PayMaya did not return a verification URL.");
      }
      window.location.href = verificationUrl;
    } catch (error) {
      alert(
        error?.response?.data?.response?.message ??
          error?.response?.data?.message ??
          error?.message ??
          "Unable to add PayMaya card."
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!headerAuth) {
      alert("Please provide header_auth!");
      return;
    }
    if (!gwOrderId) {
      alert("Please provide gwOrderId!");
      return;
    }
    if (!authenUrl) {
      alert("Please provide authenUrl!");
      return;
    }
    if (!actionPage) {
      alert("Please provide action_page!");
      return;
    }
  }, [authenUrl, actionPage, gwOrderId, headerAuth, alert]);
  return (
    <div>
      <CardInput onSubmit={onSubmit} configGateway={props} />
    </div>
  );
}
